import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedTeam = createPaginatedSlice('paginatedTeam', { defaultState: { perPage: 100 } });

export const paginatedTeamActions = paginatedTeam.actions;
export const paginatedTeamSelector = (state) => state.paginatedTeam;
export const paginatedTeamReducer = paginatedTeam.reducer;
export default paginatedTeamReducer;
